export default __webpack_public_path__ + "static/media/pip.183769ce.svg";